export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    slots: {
      default: 'opt',
    },
  },

  {
    title: that.$l('table_label_fabricPosition') || '面料位置',
    field: 'v_fabricPosition',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_Fabric_identification_name') || '面料识别名称',
    field: 'fabricIdentifyName',
    minWidth: 190,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabric_no') || '面料编号',
    field: 'fabricNo',
    width: 120,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabric_unit') || '面料单位',
    field: 'v_fabricUnit',
    width: 100,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricLoss') || '损耗',
    field: 'fabricLoss',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabric_width') || '门幅',
    field: 'fabricWidth',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_net_unit_consumption') || '净单耗',
    field: 'unitQty',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricQty') || '耗料',
    field: 'fabricQty',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_total_material_consumption') || '合计耗料',
    field: 'subQty',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_fabricWeight') || '面料克重',
    field: 'fabricWeight',
    width: 100,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_title_seq_No') || '面料序号',
    field: 'seqno',
    width: 90,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyByName',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'modifyTime',
    align: 'center',
    width: 170,
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'auto',
  },
]
